import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "_flexcol _gap-1"
}
const _hoisted_2 = {
  class: "gfu-bt gfu-bt--caption _tc--dark-gray _my-2 _tac",
  "data-qa": "mini-wizard-element:NoAddonsYet"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_heading = _resolveComponent("base-heading")
  const _component_mini_wizard_item = _resolveComponent("mini-wizard-item")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")

  return (_openBlock(), _createElementBlock("div", null, [
    (!$options.isPledgeEmpty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_base_heading, {
            tag: "h4",
            variant: "light",
            "data-qa": "mini-wizard-element:YourItems"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.MiniWizardCartItemsHeader), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.items, (item) => {
            return (_openBlock(), _createBlock(_component_mini_wizard_item, _mergeProps({
              key: item.orderItemID
            }, { ref_for: true }, item, {
              onDelete: $event => ($props.deleteMethod(item))
            }), null, 16 /* FULL_PROPS */, ["onDelete"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    ($options.showEmptyRewardsInfo)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          ($props.showRewardsHeader)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(['gfu-bt gfu-bt--caption _tc--dark-gray _mb-2 _tac', { '_mt-2': !$options.isPledgeEmpty}]),
                "data-qa": "mini-wizard-element:NoRewardsYet"
              }, _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardNoCartItemsHeader), 3 /* TEXT, CLASS */))
            : _createCommentVNode("v-if", true),
          _renderSlot(_ctx.$slots, "chooseRewardsButton", {}, () => [
            ($props.rewardsSection?.urlName)
              ? (_openBlock(), _createBlock(_component_base_button, {
                  key: 0,
                  theme: $props.buttonsTheme,
                  animation: $options.buttonAnimationType,
                  display: "block",
                  width: "narrow",
                  to: { name: 'page-section', params: { section: $props.rewardsSection.urlName } },
                  "data-qa": "mini-wizard-button:ChooseReward"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_icon, {
                      name: "plus",
                      class: "_fl"
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardChooseRewardsButton), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["theme", "animation", "to"]))
              : _createCommentVNode("v-if", true)
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    ($options.showEmptyAddonsInfo)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardNoAddonsSubheader), 1 /* TEXT */),
          _renderSlot(_ctx.$slots, "chooseAddonsButton", {}, () => [
            ($props.addonsSection?.urlName)
              ? (_openBlock(), _createBlock(_component_base_button, {
                  key: 0,
                  theme: $props.buttonsTheme,
                  animation: $options.buttonAnimationType,
                  display: "block",
                  width: "narrow",
                  class: "_mt-2",
                  to: { name: 'page-section', params: { section: $props.addonsSection.urlName } },
                  "data-qa": "mini-wizard-button:PickAddons"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_icon, {
                      name: "plus",
                      class: "_fl"
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardChooseAddonsButton), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["theme", "animation", "to"]))
              : _createCommentVNode("v-if", true)
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    ($options.showAddMoreItems)
      ? _renderSlot(_ctx.$slots, "addMoreItemsButton", {}, () => [
          ($props.rewardsSection?.urlName)
            ? (_openBlock(), _createBlock(_component_base_button, {
                key: 0,
                theme: $props.buttonsTheme,
                animation: $options.buttonAnimationType,
                display: "block",
                width: "narrow",
                class: "_mt-2",
                to: { name: 'page-section', params: { section: $props.rewardsSection.urlName } },
                "data-qa": "mini-wizard-button:AddMoreItems"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_base_icon, {
                    name: "plus",
                    class: "_fl"
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardAddMoreItemsButton), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["theme", "animation", "to"]))
            : _createCommentVNode("v-if", true)
        ], undefined, 3)
      : _createCommentVNode("v-if", true)
  ]))
}